import { useSelector } from 'react-redux';

import { ORDER_STATUS } from '~constants/orders';

export function useIsRejectedOrderScreen() {
  const activeTab = useSelector((state) => state.order.activeTab);

  const isRejectedOrderManagerScreen = activeTab?.toLowerCase() === ORDER_STATUS.REJECTED_ORDER_MANAGER;

  return isRejectedOrderManagerScreen;
}
